import * as Api from "./ApiRequest";
import * as path from "./ApiList";

export const userLogin = function (...params) {
    return Api.postRequestLogin(path.LOGIN_URL, params[0]);
}

export const userLogout = function (...params) {
    return Api.postRequest(path.LOGOUT_URL, params[0]);
}